// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__nArju","content":"LoadingAlert_content__1Mn37"};